import { render, staticRenderFns } from "./OrgDetail.vue?vue&type=template&id=667de136"
import script from "./OrgDetail.vue?vue&type=script&lang=js"
export * from "./OrgDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports